import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { ToggleButton } from 'shared/mui/ToggleButton/ToggleButton';
import { ToggleButtonGroup } from 'shared/mui/ToggleButtonGroup/ToggleButtonGroup';

type Props<T extends FieldValues> = {
  name: Path<T>;
};

export function GatewayRulesFormRuleIsAnd<T extends FieldValues>({ name }: Props<T>): JSX.Element {
  const translate = useTypedTranslate();
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, ...fieldProps } }) => {
        return (
          <ToggleButtonGroup
            {...fieldProps}
            color="primary"
            exclusive
            onChange={(_event, newValue) => {
              if (newValue !== null) {
                onChange(newValue);
              }
            }}
            size="small"
            value={value}
          >
            <ToggleButton sx={{ width: 40, height: 40 }} value={true}>
              {translate('app.common.and')}
            </ToggleButton>
            <ToggleButton sx={{ width: 40, height: 40 }} value={false}>
              {translate('app.common.or')}
            </ToggleButton>
          </ToggleButtonGroup>
        );
      }}
    />
  );
}
